export { default } from './PagePlace.vue'
